
import React from 'react';
import { X } from 'lucide-react';
import { navigationToasts } from "@/utils/toastUtils";
import { SpotlightSection } from './SpotlightSection';
import { NavigationGrid } from './NavigationGrid';
import { spotlight, column1Items, column2Items } from './menuData';
import { HomepageMegaMenuProps } from './types';

export const HomepageMegaMenu: React.FC<HomepageMegaMenuProps> = ({ onClose, onNavigationClick, onUserActivity }) => {
  const handleLinkClick = (href: string, e: React.MouseEvent) => {
    e.preventDefault();
    
    if (onNavigationClick) {
      onNavigationClick(href);
    }
    onClose();
  };

  const handleUserActivity = () => {
    if (onUserActivity) {
      onUserActivity();
    }
  };

  return (
    <div
      className="relative bg-white shadow-lg border-t border-l border-r border-b border-gray-100 z-[160] w-full max-w-5xl mx-auto overflow-hidden pointer-events-auto"
      style={{
        minWidth: 360
      }}
      tabIndex={0}
      role="dialog"
      aria-label="Homepage menu"
      onMouseMove={handleUserActivity}
      onClick={handleUserActivity}
      onKeyDown={handleUserActivity}
      onTouchStart={handleUserActivity}
    >
      {/* Close button in top-right */}
      <button
        aria-label="Close Homepage Menu"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 bg-gray-100/80 hover:bg-gray-200 focus:bg-gray-300 p-1.5 transition-all duration-150 shadow-sm border border-gray-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
        tabIndex={0}
        type="button"
      >
        <X className="w-5 h-5 text-gray-500 group-hover:text-gray-700" />
      </button>

      <div className="flex flex-col md:flex-row">
        {/* Left spotlight area */}
        <SpotlightSection 
          spotlight={spotlight} 
          onLinkClick={handleLinkClick} 
        />

        {/* Right side - Menu items with specific column layout */}
        <NavigationGrid 
          column1Items={column1Items}
          column2Items={column2Items}
          onLinkClick={handleLinkClick}
        />
      </div>
    </div>
  );
};
